import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllRestaurants } from "../redux/slices/adminRestaurantSlice";
import axiosInstance from "../utils/axios";
import { toast } from "react-toastify";

const AdminRestaurants = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [commDialog, setCommDialog] = useState({
    open: false,
    restaurant: null,
    rate: 0,
  });

  const { restaurants, loading } = useSelector(
    (state) => state.adminRestaurant,
  );

  useEffect(() => {
    dispatch(getAllRestaurants(search));
  }, [dispatch, search]);

  const getStatusColor = (status) => {
    switch (status) {
      case "ACTIVE":
        return "success";

      case "PENDING":
        return "warning";

      case "EXPIRED":
        return "error";

      default:
        return "default";
    }
  };

  const handleOpenCommission = (rest) => {
    setCommDialog({
      open: true,
      restaurant: rest,
      rate: rest.commissionRate || 0,
    });
  };

  const handleSaveCommission = async () => {
    try {
      await axiosInstance.put(
        `/api/admin/restaurant/${commDialog.restaurant._id}/commission`,
        {
          commissionRate: Number(commDialog.rate),
        },
      );
      toast.success(`Commission set to ${commDialog.rate}%`);
      setCommDialog({ open: false, restaurant: null, rate: 0 });
      // Refresh restaurants list (jo bhi aapka existing fetch function hai use call karein)
      window.location.reload();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update commission");
    }
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} mb={3}>
        Restaurants
      </Typography>

      <Paper
        sx={{
          p: 2,
          mb: 3,
        }}
      >
        <TextField
          fullWidth
          label="Search Restaurant"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Paper>

      <Paper sx={{ p: 2 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={5}>
            <CircularProgress />
          </Box>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Restaurant</TableCell>

                <TableCell>Owner</TableCell>

                <TableCell>Mobile</TableCell>

                <TableCell>Commission Rate</TableCell>

                <TableCell>Subscription</TableCell>

                <TableCell>Plan Expiry</TableCell>

                <TableCell>Active</TableCell>

                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {restaurants?.map((restaurant) => (
                <TableRow key={restaurant._id}>
                  <TableCell>{restaurant.restaurantName}</TableCell>

                  <TableCell>{restaurant.ownerName}</TableCell>

                  <TableCell>{restaurant.mobile}</TableCell>

                  <TableCell>
                    <Chip
                      label={`${restaurant.commissionRate || 0}%`}
                      color="secondary"
                      size="small"
                      sx={{ fontWeight: "bold", mr: 1 }}
                    />
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => handleOpenCommission(restaurant)}
                    >
                      Set %
                    </Button>
                  </TableCell>

                  <TableCell>
                    <Chip
                      label={restaurant.subscriptionStatus}
                      color={getStatusColor(restaurant.subscriptionStatus)}
                    />
                  </TableCell>

                  <TableCell>
                    {restaurant.planExpiryDate
                      ? new Date(restaurant.planExpiryDate).toLocaleDateString()
                      : "-"}
                  </TableCell>

                  <TableCell>
                    <Chip
                      label={restaurant.isActive ? "Active" : "Inactive"}
                      color={restaurant.isActive ? "success" : "error"}
                    />
                  </TableCell>

                  <TableCell>
                    {/* <Button
                        size="small"
                        variant="contained"
                      >
                        View
                      </Button> */}
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() =>
                        navigate(`/admin/restaurants/${restaurant._id}`)
                      }
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>

      <Dialog open={commDialog.open} onClose={() => setCommDialog({ open: false, restaurant: null, rate: 0 })}>
  <DialogTitle>
    Set Commission % — {commDialog.restaurant?.restaurantName}
  </DialogTitle>
  <DialogContent sx={{ pt: 2 }}>
    <TextField
      autoFocus
      fullWidth
      type="number"
      label="Commission Percentage (e.g. 15 or 20)"
      value={commDialog.rate}
      onChange={(e) => setCommDialog({ ...commDialog, rate: e.target.value })}
      inputProps={{ min: 0, max: 100 }}
      sx={{ mt: 1 }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setCommDialog({ open: false, restaurant: null, rate: 0 })}>Cancel</Button>
    <Button variant="contained" onClick={handleSaveCommission}>Save Commission</Button>
  </DialogActions>
</Dialog>
    </Box>
  );
};

export default AdminRestaurants;
